module.exports = __webpack_public_path__ + "static/media/loading-animation.1463adea.svg";